import { render, staticRenderFns } from "./referenceList.vue?vue&type=template&id=aa7e5cc0&"
import script from "./referenceList.vue?vue&type=script&lang=ts&"
export * from "./referenceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports